module.exports = __webpack_public_path__ + "static/GoingHomeLogo-169d1d356d05f3a1839cfb6f00be12d9.jpg";